import Component from '@glimmer/component';
import { cached } from '@glimmer/tracking';
import Scopes from '@linc-technologies/linced-common/enums/scopes';

// ReportTimelineCard is one timeline item on the group hub: the report name,
// its period, and a status card with the actions for that period. Used by the
// Active section (current period) and the Report history section (past
// periods).
//
// Args:
//  - report, drafts, group: the template, its counts entry, and the group.
//  - periodIndex: the period this card represents.
//  - isTemplateDeleted: shows a "Template deleted" chip next to the name.
//  - isLast: the final card in its timeline run; hides the trailing connector.
//  - isHistoric: a closed period. Reports already written in it can still be
//    finished, reviewed and published, but no new drafts can be started. A
//    period is addressed by its index within a template version, and editing a
//    template can insert, remove or reorder periods, so an index resolved today
//    does not reliably point at the period a closed card shows.
//  - loadingReportId, isLoadingDraftInfo, canEditLeadershipComment: state.
//  - onWriteReports, onReviewReports, onPublishReports, onSelectReport,
//    onWriteComments, onViewReports: each is called with (report, period).
export default class ReportTimelineCard extends Component {
  Scopes = Scopes;

  // The period every action on this card acts against, built once rather than
  // repeated per button so the card and the screen it opens cannot disagree
  // about which period they mean.
  @cached
  get period() {
    return {
      index: this.args.periodIndex,
      endDate: this.args.drafts?.periodEndDate,
      year: this.args.drafts?.year,
      isHistoric: this.args.isHistoric ?? false,
    };
  }
}
